import axios from "axios"

const journalApi = axios.create({
    baseURL: 'https://vue-daybook-59f9c-default-rtdb.firebaseio.com'
})

export default journalApi